import type { StatesConfig } from 'xstate'
import type { TStep } from 'src/types'
import { PageId } from 'constants/pages'
import { getIntellioResumeTarget } from 'helpers/getIntellioResumeTarget'

export const getXStateConfigWoofzInt1T = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    always: [
      {
        target: getIntellioResumeTarget({
          pages,
          pageIds: {
            certificate: PageId.CERTIFICATE_INTL_1T,
            nameEntry: PageId.NAME_ENTRY_INTL_1T,
            offer: PageId.OFFER_INTL_1T,
            registration: PageId.REGISTRATION_INTL_1T,
            report: PageId.REPORT_INTL_1T,
          },
        }),
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId ?? pages[index].pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          SKIP_ONE_STEP: {
            target:
              index + 2 < pages.length
                ? pages[index + 2].pageId
                : pages[index].pageId,
          },
          SKIP_ONE_STEP_BACK: {
            target:
              index - 2 >= 0 ? pages[index - 2].pageId : pages[index].pageId,
          },
          POST_PAYMENT_CONTINUE: {
            target: PageId.REGISTRATION_INTL_1T,
          },
          ...(page.pageId === PageId.EMAIL_INTL_1T && {
            PREVIOUS_FLOW_STEP: { target: PageId.DISCOVER_FEEDBACKS_INTL_1T },
          }),
        },
      },
    }),
    {},
  ),
  // [PageId.DOWNLOAD_ESA]: {
  //   type: 'final',
  // },
})
